import React from 'react';
import LearningCenterAccessDenied from '@/components/controls/LearningCenterAccessDenied';
import '../login/Login.scss';

/** Public route; "Go to Portal home" signs out via Auth0 so academy retry does not auto-loop. */
const LearningCenterAccessDeniedPage = () => (
	<div className="loginContainer" data-testid="learning-center-access-denied-page">
		<LearningCenterAccessDenied />
	</div>
);

export default LearningCenterAccessDeniedPage;
